import { Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment';
import React, { useEffect } from 'react'
import ApiServices from '../services/ApiServices';

export default function DeviceLog(props) {
    const columns = [ 
        { field: 'createdAt', headerName: 'createdAt', flex: 0.5 , sortable: false,renderCell: (params) =>{
            if(params.row.createdAt){                 
                return moment(params.row.createdAt).format("DD-MM-YYYY h:mm:ss a");
           } 
        } },
        { field: 'topicType', headerName: 'Topic Type', flex: 0.5 , sortable: false,renderCell: (params) => renderValue(params.row.topicType)},
        { field: 'message', headerName: 'Message', flex: 0.5 , sortable: false,renderCell: (params) => renderValue(params.row.message)},
    ];
    const renderValue = (value) => {
        return <div style={{ lineHeight: "1.2", overflowWrap: "break-word", whiteSpace: "normal", overflow: "auto", maxHeight: "inherit" }}>{value}</div>
    }
    const [deviceLog, setDeviceLog] = React.useState([]);
    const { imei } = props;
    useEffect(() => {
        ApiServices.fetchLogOfDevice(imei)
            .then(response => {
                if (response.status === 200) {
                    setDeviceLog(response.data);
                } else {
                    setDeviceLog([]);
                }

            })
            .catch(error => {
                console.error(error);
                setDeviceLog([]);
            })
    }, [imei])
    return (
        <Box
            sx={{
                width: 1500,
                maxHeight: 500
            }}
        >
            <DataGrid
                getRowId={(row) => row.createdAt}
                rows={deviceLog}
                columns={columns}
                disableSelectionOnClick
                disableColumnMenu
                pageSize={20}
                autoHeight={true}
            />
        </Box>
    )
}
